import React from "react";

interface WeddnLoaderProps {
  message?: string;
  variant?: "fullscreen" | "contained" | "inline";
  size?: "sm" | "md" | "lg";
  showMessage?: boolean;
  className?: string;
}

const WeddnLoader: React.FC<WeddnLoaderProps> = ({
  message = "Loading...",
  variant = "contained",
  size = "md",
  showMessage = true,
  className = ""
}) => {
  const getContainerClasses = () => {
    const baseClasses = "flex flex-col items-center justify-center";

    switch (variant) {
      case "fullscreen":
        return `fixed inset-0 z-50 ${baseClasses} bg-black/50 backdrop-blur-md`;
      case "contained":
        return `${baseClasses} p-8`;
      case "inline":
        return `${baseClasses} p-4`;
      default:
        return `${baseClasses} p-8`;
    }
  };

  const getLogoClasses = () => {
    const baseClasses = "dcalligraphy font-normal animate-pulse";
    const colorClasses = variant === "fullscreen" ? "text-white" : "text-gray-800";

    const sizeClasses = {
      sm: "text-2xl md:text-3xl",
      md: "text-4xl md:text-5xl",
      lg: "text-5xl md:text-6xl"
    }[size];

    return `${baseClasses} ${colorClasses} ${sizeClasses}`;
  };

  const getTextClasses = () => {
    const colorClasses = variant === "fullscreen" ? "text-gray-300" : "text-gray-600";
    const sizeClasses = {
      sm: "text-xs",
      md: "text-sm",
      lg: "text-base"
    }[size];

    return `${colorClasses} ${sizeClasses}`;
  };

  const getLogoStyle = () => {
    const shadowIntensity = variant === "fullscreen" ? "0.3" : "0.1";
    return {
      transform: 'rotate(-8deg)',
      textShadow: `0 2px 4px rgba(0,0,0,${shadowIntensity})`
    };
  };

  const getMbClass = () => {
    if (!showMessage) return "";
    return {
      sm: "mb-2",
      md: "mb-4",
      lg: "mb-6"
    }[size];
  };

  return (
    <div className={`${getContainerClasses()} ${className}`}>
      <div className={getMbClass()}>
        <span
          className={getLogoClasses()}
          style={getLogoStyle()}
        >
          Weddn.co
        </span>
      </div>
      {showMessage && (
        <p className={getTextClasses()}>{message}</p>
      )}
    </div>
  );
};

export default WeddnLoader;